
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gifts/basket",
      function () {
        return require("private-next-pages/gifts/basket.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gifts/basket"])
      });
    }
  